import { SelectOptionTypes } from "../../../../components/Input";

export const FORM_ID = "investment-goal-form";

export const CADENCE_OPTIONS: SelectOptionTypes[] = [
  { label: "Monthly", value: "MONTHLY" },
  { label: "Yearly", value: "YEARLY" },
];

export const DEFAULT_INVESTMENT_GOAL = {
  name: "",
  targetAmount: 0,
  assumedAnnualReturn: 0.07,
  contributionRate: 0,
  contributionCadence: CADENCE_OPTIONS[0],
  accountIds: [] as number[],
};
